import { render } from "./NewsCommunity.vue?vue&type=template&id=33d2d46e&scoped=true"
import script from "./NewsCommunity.vue?vue&type=script&lang=js"
export * from "./NewsCommunity.vue?vue&type=script&lang=js"

import "./NewsCommunity.vue?vue&type=style&index=0&id=33d2d46e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d2d46e"]])

export default __exports__